import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in Touch`}</h2>
    <p>{`Say Hi or find me on other platforms `}</p>
    <pre>  
      <a href="https://www.linkedin.com/in/thetseffect"><img src="https://www.freepnglogos.com/uploads/linkedin-social-media-logo-7.png" width="30" alt="linkedin social media logo" /></a> <a href="https://github.com/tarunnsingh"><img src="https://www.freepnglogos.com/uploads/512x512-logo/512x512-transparent-logo-github-logo-24.png" width="30" alt="linkedin social media logo" /></a> <a href="https://www.medium.com/@thetseffect"><img src="https://cdn4.iconfinder.com/data/icons/social-media-2210/24/Medium-512.png" width="30" alt="linkedin social media logo" /></a> <a href="https://twitter.com/tarunsingh_t49"><img src="https://www.freepnglogos.com/uploads/twitter-logo-png/twitter-logo-vector-png-clipart-1.png" width="30" alt="instagram logo png transparent" /></a> <a href="https://instagram.com/tarunsingh_49f"><img src="https://www.freepnglogos.com/uploads/instagram-logo-png-transparent-0.png" width="30" alt="instagram logo png transparent" /></a> <a href="https://facebook.com/TarunSinghT49"><img src="https://www.freepnglogos.com/uploads/facebook-logo-13.png" width="30" alt="instagram logo png transparent" /></a>
    </pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      